import { render, staticRenderFns } from "./goldList.vue?vue&type=template&id=24469f13&scoped=true"
import script from "./goldList.vue?vue&type=script&lang=js"
export * from "./goldList.vue?vue&type=script&lang=js"
import style0 from "./goldList.vue?vue&type=style&index=0&id=24469f13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24469f13",
  null
  
)

export default component.exports